import { StringUtil } from "@gipisistemas/ng-core";

export class PdfUtil {
    constructor() { }

    public static print(pdfUrl: string): void {
        if (StringUtil.isEmpty(pdfUrl)) {
            throw new Error("O URL do PDF é obrigatório para impressão");
        }

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";

        iframe.src = pdfUrl;

        iframe.onload = () => {
            setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }, 500);
        };

        document.body.appendChild(iframe);
    }
}

